<template>
  <ModalActionConfirmation
    ref="modalConfirmation"
    message="Você possui algumas alterações que não foram salvas. O que deseja fazer?"
    btnCancelText="Sair sem salvar"
    btnConfirmText="Salvar alterações"
    @cancelled="close()"
    @confirmed="save()"
  />
</template>

<script>
import ModalActionConfirmation from '@/components/Shared/ModalActionConfirmation.vue'

export default {
  components: {
    ModalActionConfirmation,
  },

  computed: {
    showModalChangesUnsaved: {
      get() {
        return this.$store.state.app.showModalChangesUnsaved
      },
      set(payload) {
        this.$store.dispatch('app/setShowModalChangesUnsaved', payload)
      },
    },
    elementsIDToFocusBeforeEachRouter: {
      get() {
        return this.$store.state.app.elementsIDToFocusBeforeEachRouter
      },
      set(payload) {
        this.$store.dispatch(
          'app/setElementsIDToFocusBeforeEachRouter',
          payload
        )
      },
    },
    routeStoppedByChangesUnsaved: {
      get() {
        return this.$store.state.app.routeStoppedByChangesUnsaved
      },
      set(payload) {
        this.$store.dispatch('app/setRouteStoppedByChangesUnsaved', payload)
      },
    },
  },

  watch: {
    elementsIDToFocusBeforeEachRouter(newValue) {
      if (newValue.length) this.addEventBeforeUnload()
      else this.removeEventBeforeUnload()
    },

    showModalChangesUnsaved(newValue) {
      if (newValue) this.$refs.modalConfirmation.open()
    },
  },

  beforeUnmount() {
    this.removeEventBeforeUnload()
  },

  methods: {
    eventBeforeUnload(event) {
      this.scrollToElement()
      const confirmationMessage = 'ok'
      event.returnValue = confirmationMessage
      return confirmationMessage
    },

    addEventBeforeUnload() {
      window.addEventListener('beforeunload', this.eventBeforeUnload)
    },

    removeEventBeforeUnload() {
      window.removeEventListener('beforeunload', this.eventBeforeUnload)
    },

    scrollToElement() {
      const index = this.elementsIDToFocusBeforeEachRouter.length - 1
      this.$scrollTo(`#${this.elementsIDToFocusBeforeEachRouter[index]}`)
    },

    close() {
      this.removeEventBeforeUnload()
      this.elementsIDToFocusBeforeEachRouter = []
      this.showModalChangesUnsaved = false
      this.$router.push(this.routeStoppedByChangesUnsaved)
      this.routeStoppedByChangesUnsaved = undefined
    },

    save() {
      this.showModalChangesUnsaved = false
      this.scrollToElement()
    },
  },
}
</script>

<style lang="scss"></style>
